import React, { FunctionComponent } from "react";

import { FiltersPanel } from "../../../FiltersSidebar/FiltersPanel";
import { useTireResults } from "../useTireResults";
import { TireCategoryFilters } from "./Category/Category";
import { TireOriginalEquipmentFilters } from "./OriginalEquipment/OriginalEquipment";
import { TireRunFlatFilters } from "./RunFlat/RunFlatFilters";
import { TireBrandFilters } from "./TireBrandFilters/TireBrandFilters";
import { TireLoadRaitingFilters } from "./TireLoadRaitingFilters/TireLoadRaitingFilters";
import { TirePlyRaitingFilters } from "./TirePlyRaitingFilters/TirePlyRaitingFilters";
import { TirePriceFilters } from "./TirePriceFilters/TirePriceFilters";
import { TireSeasonFilters } from "./TireSeasonFilters/TireSeasonFilters";
import { TireSizeFilters } from "./TireSizeFilters/TireSizeFilters";
import { TireSpeedIndexFilters } from "./TireSpeedIndexFilters/TireSpeedIndexFilters";

export const TireFilters: FunctionComponent<{ onClose(): void }> = ({
  onClose,
}) => {
  const { isLoading } = useTireResults();
  return (
    <FiltersPanel loading={isLoading} onClose={onClose}>
      <TireSeasonFilters />
      <TireSizeFilters />
      <TireOriginalEquipmentFilters />
      <TireCategoryFilters />
      <TireRunFlatFilters />
      <TireBrandFilters />
      <TirePriceFilters />
      <TireLoadRaitingFilters />
      <TireSpeedIndexFilters />
      <TirePlyRaitingFilters />
    </FiltersPanel>
  );
};
